// extracted by mini-css-extract-plugin
export default {"container":"InfoHeader_container_xNwNE","content":"InfoHeader_content_RptMI","action":"InfoHeader_action_QJIbo"};